import { useContext, useLayoutEffect, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import type { ComponentEnhancer } from 'recompose';

import { LocalAuthContext } from '~/components/Auth';
import type { TMicroApps } from '~/components/Auth';

import useDatadog from '../hooks/useDatadog';

const withDatadogApplicationScope = <P extends {}>({
  appName,
  streamName,
}: {
  appName: TMicroApps;
  streamName: string;
}) => {
  const enhancer = (Component: React.ComponentType<P>) => (props: P) => {
    const auth = useContext(LocalAuthContext);
    let location = useLocation();
    const {
      resetApplicationContext,
      updateApplicationContext,
      resetApplicationLevelContext,
    } = useDatadog(auth!);

    useEffect(() => {
      resetApplicationLevelContext();
      // eslint-disable-next-line
    }, [location]);

    useLayoutEffect(() => {
      updateApplicationContext(streamName, appName);
      return resetApplicationContext;
    }, [resetApplicationContext, updateApplicationContext]);

    return <Component {...props} />;
  };
  return (enhancer as unknown) as ComponentEnhancer<P, P>;
};

export default withDatadogApplicationScope;
